import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { StyledTimeFormat, StyledTimeFormatList } from './style';
import { AM_PM } from '../constants';

export default function TimeFormatList(props) {
  const { hour, currentTimeFormat, onSelectNewTimeFormat, minHours, maxHours } = props;

  // If there is no selected format time (am / pm), set the format time depending on the hour.
  useEffect(() => {
    if (!currentTimeFormat) {
      if (hour >= 12) {
        onSelectNewTimeFormat('pm');
      } else {
        onSelectNewTimeFormat('am');
      }
    }
  }, [hour, onSelectNewTimeFormat, currentTimeFormat]);

  const isSelected = (newTimeFormat) => {
    if (!currentTimeFormat) {
      return false;
    }
    return newTimeFormat === currentTimeFormat;
  };

  const isTimeFormatDisabled = (timeFormat) => {
    if (minHours === undefined || maxHours === undefined) return false;

    if (timeFormat === 'am') {
      // AM hours are 0-11 (12 AM = 0, 1-11 AM = 1-11)
      // Disable AM if minHours >= 12 (no AM hours are valid)
      const shouldDisable = minHours >= 12;
      return shouldDisable;
    }
    if (timeFormat === 'pm') {
      // PM hours are 12-23 (12 PM = 12, 1-11 PM = 13-23)
      // Disable PM if maxHours < 12 (no PM hours are valid)
      const shouldDisable = maxHours < 12;
      return shouldDisable;
    }

    return false;
  };

  const selectFormatHandler = (newTimeFormat) => (event) => {
    if (newTimeFormat === currentTimeFormat) {
      event.preventDefault();
      return;
    }
    onSelectNewTimeFormat(newTimeFormat);
  };

  return (
    <StyledTimeFormatList data-testid="time-format">
      {AM_PM.map((timeFormat, index) => (
        <StyledTimeFormat
          key={`${timeFormat}-${index}`}
          isSelected={isSelected(timeFormat)}
          disabled={isTimeFormatDisabled(timeFormat)}
          onClick={selectFormatHandler(timeFormat)}
          aria-selected={isSelected(timeFormat) ? true : undefined}
        >
          {timeFormat}
        </StyledTimeFormat>
      ))}
    </StyledTimeFormatList>
  );
}

TimeFormatList.propTypes = {
  hour: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  currentTimeFormat: PropTypes.oneOf(AM_PM),
  onSelectNewTimeFormat: PropTypes.func.isRequired,
  minHours: PropTypes.number,
  maxHours: PropTypes.number,
};
